import { exportFileFormat } from '../../../utils/ExportPemFileUtil'
import interceptedAxios from '../../../utils/interceptedAxios'

export async function exportSMimeCertificateService (
  label: string,
  onSuccess: (exportFile: any) => any,
  onFailure: (errorMessage: string | undefined) => any
): Promise<void> {
  const url = `/app-config-service/api/v1/crypto/export/s-mime/kek/${encodeURIComponent(label)}`
  try {
    const response = await interceptedAxios.get(url, { responseType: 'blob' })
    exportFileFormat(response, label)
    onSuccess(response)
  } catch (error: any) {
    onFailure(error.message)
  }
}
